import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center nst-light px-6">
      <div className="text-center max-w-md">
        <div className="text-[120px] font-extrabold text-[#0A1F47] leading-none">404</div>
        <h1 className="text-2xl font-bold text-[#0A1F47] mt-4">Page Not Found</h1>
        <p className="mt-2 text-[#0A1F47]/70">
          The page you’re looking for doesn’t exist or has been moved.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/" className="btn-navy">
            <Home className="w-4 h-4" /> Go Home
          </Link>
          <button onClick={() => window.history.back()} className="btn-ghost-dark">
            <ArrowLeft className="w-4 h-4" /> Back
          </button>
        </div>
      </div>
    </div>
  );
}
